import React, { Component } from 'react';
import { Steps, Icon, Row, Col, Card } from 'antd';
import { RTLStep, RTLButton } from '../RTLKit';




export default class Register extends Component {

    constructor(props) {
        super(props);
        this.props.onPageLoad('RegisterPage');
        this.state = {
            current: 0,
        };
    }

    

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    render () {
        return(
            <Row type="flex" justify="space-around" align="middle">
                <Col span={12}>
                    <Card style={{marginTop: '30%'}}>
                        <img src={require(`../../assets/image/clodify.svg`)} alt="" style={{marginBottom: '30px'}}/>
                        <Steps direction="horizontal" size="small" current={this.state.current}>
                            <RTLStep title="ایمیل" description="ورود ایمیل و رمز عبور" icon={<Icon type="user" />}/>
                            <RTLStep title="کد فعال سازی" description="تایید ایمیل با کد فعالسازی" icon={<Icon type="unlock" />}/>
                            <RTLStep title="ثبت نام" description="تکمیل ثبت نام و ورود به سامانه" icon={<Icon type="smile-o" />}/>
                        </Steps>
                        { this.state.current !== 2 && <RTLButton type="primary" shape="round" htmlType="submit" style={{marginTop: '40px'}} onClick={() => this.next()}>
                                بعد
                        </RTLButton>}

                        { this.state.current !== 0 && <RTLButton shape="round" htmlType="submit" style={{marginTop: '40px'}} onClick={() => this.prev()}>
                                قبل
                        </RTLButton>}
                    </Card>
                </Col>
            </Row>
        );
    }
}
